// import { ReactComponent as UserIcon } from "../images/irm-icon-users.svg";
import Settings from '@mui/icons-material/Settings';
import Logout from '@mui/icons-material/Logout';
import Info from '@mui/icons-material/Info';
import PersonIcon from '@mui/icons-material/Person';

export const MENU_LIST = [
    // {
    //   label: 'Preferences',
    //   icon: Settings,
    //   link: '/preferences'
    // },
    {
      label: 'My Profile',
      icon: PersonIcon,
      link: '/profile'
    },
    {
      label: 'Logout',
      icon: Logout,
      link: '/logout'
    },
    {
      label: 'V2.2.3',
      icon: Info,
      link: 'null'
    }
  ];